export default "__VITE_ASSET__DjTNSs_Y__"